import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAkLpKaOZppF8Ke83Xm3b0jGQNqd9WRWuE',
    libraries: 'places',
  },
});
